export default "__VITE_ASSET__CUNOsl5X__"